import { __rest, __assign } from '../../../node_modules/tslib/tslib.es6.js';
import { jsx, Fragment } from 'react/jsx-runtime';
import { Table as Table$1 } from 'reactstrap';
import { HTML5Backend } from '../../../node_modules/react-dnd-html5-backend/dist/index.js';
import classNames from 'classnames';
import { TableContext } from './TableContext.js';
import { Cell } from './Cell.js';
import { ActionCell } from './ActionCell.js';
import { ActionHeader } from './ActionHeader.js';
import { Body } from './Body.js';
import { Header } from './Header.js';
import { HeaderRow } from './HeaderRow.js';
import { TablePaginationRow } from './TablePaginationRow.js';
import { Row } from './Row.js';
import { TableSearch } from './TableSearch.js';
import { TableHead } from './Head.js';
import { PageIndexInput } from './PageIndexInput.js';
import { PageSizeSelect } from './PageSizeSelect.js';
import { PaginationInfo } from './PaginationInfo.js';
import { TablePagination } from './TablePagination.js';
import { OptionsCell } from './OptionsCell.js';
import { OptionsHeader } from './OptionsHeader.js';
import { DndProvider } from '../../../node_modules/react-dnd/dist/core/DndProvider.js';

var Table = function (_a) {
    var allSelected = _a.allSelected, children = _a.children, className = _a.className, _b = _a.fixed, fixed = _b === void 0 ? false : _b, onRowMoved = _a.onRowMoved, onRowSelect = _a.onRowSelect, onSelectAll = _a.onSelectAll, _c = _a.responsive, responsive = _c === void 0 ? true : _c, selectedIndexes = _a.selectedIndexes, _d = _a.size, size = _d === void 0 ? 'md' : _d, someSelected = _a.someSelected, _e = _a.stickyColumn, stickyColumn = _e === void 0 ? false : _e, striped = _a.striped, tableProps = __rest(_a, ["allSelected", "children", "className", "fixed", "onRowMoved", "onRowSelect", "onSelectAll", "responsive", "selectedIndexes", "size", "someSelected", "stickyColumn", "striped"]);
    var TableParent = function (_a) {
        var children = _a.children;
        return onRowMoved ? jsx(DndProvider, __assign({ backend: HTML5Backend }, { children: children })) : jsx(Fragment, { children: children });
    };
    return (jsx(TableContext.Provider, __assign({ value: {
            allSelected: allSelected,
            onSelectAll: onSelectAll,
            onRowSelect: onRowSelect,
            onRowMoved: onRowMoved,
            someSelected: someSelected,
            selectedIndexes: selectedIndexes
        } }, { children: jsx(TableParent, { children: jsx(Table$1, __assign({}, tableProps, { responsive: responsive, className: classNames(className, stickyColumn && 'table-column-sticky', onRowSelect && 'table-row-selection', fixed && 'table-layout-fixed', 
                // Reactstrap striped prop is a boolean, .table-striped is gray, the rest extend it
                striped && striped !== 'gray' && "table-striped-".concat(striped)), striped: !!striped, size: size !== 'md' ? size : undefined, "data-testid": "table" }, { children: children })) }) })));
};
Table.Body = Body;
Table.Cell = Cell;
Table.ActionCell = ActionCell;
Table.ActionHeader = ActionHeader;
Table.PaginationRow = TablePaginationRow;
Table.Head = TableHead;
Table.Header = Header;
Table.HeaderRow = HeaderRow;
Table.OptionsCell = OptionsCell;
Table.OptionsHeader = OptionsHeader;
Table.PageIndexInput = PageIndexInput;
Table.PageSizeSelect = PageSizeSelect;
Table.Pagination = TablePagination;
Table.PaginationInfo = PaginationInfo;
Table.Row = Row;
Table.Search = TableSearch;

export { Table };
